// web_components/wcConsentModal/wcConsentManageModal_Renderer.ts

/**
 * Generates the HTML for the wc-consent-manage-modal component.
 * Handles CSS, variables, etc.
 *
 * @param {string} instanceId - A unique instance ID for generating unique element IDs.
 * @returns {string} - The HTML string for the content component.
 */
export function renderProductHTML(instanceId: string): string {
	return `
        <style>
            .sr-only {
                /** Where would this be used? When we know, use %sr-only placeholder in the SCSS instead **/
                position: absolute;
                width: 1px;
                height: 1px;
                padding: 0;
                margin: -1px;
                overflow: hidden;
                clip: rect(0, 0, 0, 0);
                border: 0;
            }
        </style>
        
        <div id="${instanceId}" class="wc-consent-manage-modal" role="dialog" aria-labelledby="consentManageTitle" aria-describedby="consentManageDescription" aria-modal="true" tabindex="-1">
        	<div class="wc-modal__overlay"><i></i></div>
            <div class="wc-modal__dialog">
        	    <div class="wc-modal__body">
                    <form>
                        <h2>Manage Cookie Preferences</h2>
                        <p class="wc-consent-manage-modal__description">
                          See what all our cookies do below, and set your preferences. Note that turning any of these cookies off may affect your browsing experience. See our <a href="/cookies">Cookie Policy</a> for more information. By closing this dialog you will confirm your cookie preferences.
                        </p>
                        <fieldset>
                            <legend>
                                <h4>Essential cookies</h4>
                            </legend>
                            <p>Our website won't work properly without essential cookies. They help you move around the secure areas of the website, letting you do things like using your shopping basket or talking to us online through Live Chat. These cookies cannot be turned off.</p>
                            <div>
                                <label id="wc-consent-manage-modal__essential-label" for="wc-consent-manage-modal__essential-input" class="disabled">Essential cookies are always enabled for proper website functionality.</label>
                                <input id="wc-consent-manage-modal__essential-input" type="checkbox" disabled checked aria-checked="true" aria-disabled="true" aria-labelledby="wc-consent-manage-modal__essential-label" />
                            </div>
                        </fieldset>
        
                        <fieldset>
                            <legend>
                                <h4>Functional & performance cookies</h4>
                            </legend>
                            <p>Our functional cookies help us to test new elements of our website. They also help us to personalise things so that we can show relevant offers and products to customers. They show us how our website is performing, and help improve your browsing experience. These cookies never identify individual users.</p>
                            <div>
                                <label id="wc-consent-manage-modal__functional-label" for="wc-consent-manage-modal__functional-input">Allow functional and performance cookies</label>
                                <input id="wc-consent-manage-modal__functional-input" type="checkbox" aria-checked="false" aria-labelledby="wc-consent-manage-modal__functional-label" />
                            </div>
                        </fieldset>
        
                        <fieldset>
                            <legend>
                                <h4>Marketing cookies</h4>
                            </legend>
                            <p>These cookies collect information about your browsing habits to show you advertisements relevant to your interests, including remarketing on external websites, based on the products you've viewed.</p>
                            <div>                        
                                <label id="wc-consent-manage-modal__marketing-label" for="wc-consent-manage-modal__marketing-input">Allow marketing cookies</label>
                                <input id="wc-consent-manage-modal__marketing-input" type="checkbox" aria-checked="false" aria-labelledby="wc-consent-manage-modal__marketing-label" />
                            </div>
                        </fieldset>
        
                        <p>Please note: Turning off cookies will prevent any future cookies from being set. To remove existing cookies, clear the cookies cache in your browser.</p>
        
                        <button class="wc-consent-manage-modal__save-btn" aria-label="Save cookie preferences" type="submit">Save Preferences</button>
                    </form>
                </div>
            </div>
        </div>
    `;
}
